import { render } from "./CollapseDrawerIcon.vue?vue&type=template&id=85fcef28"
import script from "./CollapseDrawerIcon.vue?vue&type=script&lang=js"
export * from "./CollapseDrawerIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__